<template>
  <v-app-bar
    color="primary"
    dark
    app
  >
    <v-app-bar-nav-icon @click.stop="handleDrawerToggle"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>

    <v-menu offset-y offset-overflow origin="left top" min-width="150px" transition="scale-transition">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text>
          <v-icon class="mr-1">mdi mdi-account</v-icon>
          {{name}}
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item v-for="(item,index) in items" :to="!item.href ? '#' : item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
          <v-list-item-icon v-if="item.icon">
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import helper from "@/helpers";
import AppLang from "./AppLang";
export default {
  name: 'app-toolbar',
  components: { AppLang },
  data: () => ({
    items: [
      {
        icon: 'mdi-power',
        title: 'A00002',
        click: (e) => {
          helper.logout().then(() => {
            window.location.reload();
          });
        }
      }
    ],
    email:'',
    name:'',
  }),
  created() {
    // axios.get('/api/auth/user')
    //   .then(response => response.data.data)
    //   .then(response => {
    //   this.email = response.user.email;
    //   this.name = response.user.name;
    // });
  },
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  methods: {
    handleDrawerToggle () {
     
      this.$emit('toggle_sidebar');
      console.log('hide1')
    },
  }
};
</script>

